import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';

import { colors, layout } from 'Constants';

import { Container, Footnote, Anchor } from 'Components/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FacebookIcon from './images/footer_fb.svg';
import TwitterIcon from './images/footer_twitter.svg';
import YoutubeIcon from './images/footer_yt.svg';

import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';
import CODES from 'Root/libs/analytics/CodeDef';

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #081f65;//${colors.accent};
  padding: 32px;
  color: ${colors.textOnAccent};
  text-align: center;
`;


const ISHelpFull = styled.div`
  display: flex;
  text-align: center;
  background-color:#0054f1 ;
  width:100% ;
  justify-content: center;
  height :40px ;
  vertical-align:center;
  align-items:center;
  color: #ffffff;
  font-size :19px ;

`;


// TODO: Implement API values
export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <div>
         <ISHelpFull>
          Was this information helpful?&nbsp;&nbsp; 
           <Anchor
          style={{textDecoration:'underline'}}
          code={CODES.EXT_CLICK} to={state?.brandInfo?.surveyLink}    color={colors.textOnAccent} target="_blank"> Let us know</Anchor>.
          </ISHelpFull>
      <FooterContainer>
        
        
        <Container
          seperation="24px"
          alignItems
          column
          style={{ maxWidth: layout.maxWidth, width: '100%' }}
        >
         
          <Container seperation="36px" style={{ alignSelf: 'center' }}>
            <Anchor code={CODES.FOOT_SOCIAL_FB} to={state.socials.facebook} target="_blank">
              <img
                alt="Facebook"
                src={FacebookIcon}
                style={{ width: '2.5em', height: '100%' }}
              />
            </Anchor>
            <Anchor code={CODES.FOOT_SOCIAL_TW} to={state.socials.twitter} target="_blank">
              <img
                alt="Twitter"
                src={TwitterIcon}
                style={{ width: '2.5em', height: '100%' }}
              />
            </Anchor>
            <Anchor code={CODES.FOOT_SOCIAL_YT} to={state.socials.youtube} target="_blank">
              <img
                alt="Youtube"
                src={YoutubeIcon}
                style={{ width: '2.5em', height: '100%' }}
              />
            </Anchor>
          </Container>
          <p>
            <Anchor code={CODES.FOOT_ANTHEM_LINK} to={state.brandInfo.webLink} color={colors.textOnAccent}>
              {state.brandInfo.name}
            </Anchor>{' '}
            |{' '}
            <Anchor
              code={CODES.FOOT_PP_LINK}
              to={state.brandInfo.privacyPolicy}
              color={colors.textOnAccent}
            >
              PRIVACY POLICY
            </Anchor>{' '}
            |{' '}
            <Anchor code={CODES.FOOT_LEGAL_LINK} to={state.brandInfo.legal} color={colors.textOnAccent}>
              LEGAL
            </Anchor>
          </p>
          <Footnote>{state.brandInfo.legalText}</Footnote>
        </Container>
      </FooterContainer>
      </div>
    )}
  </Subscribe>
);
